import { RoadDetailInfo } from "@l2r-front/l2r-networks"
import {
    styled,
    styledForMobile,
    Typography,
} from "@l2r-front/l2r-ui"

import { RoadworkDetails as L2RRoadworkDetails } from "../RoadworkDetails"

export const Container = styledForMobile("div")(() => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
}))

export const SegmentDetailInfo = styledForMobile(RoadDetailInfo)(({ isMobile, theme }) => ({
    margin: 0,
    padding: isMobile ? theme.spacing(0, 4) : theme.spacing(0, 8),
}))

export const NetworkGradingSelectorDescription = styled(Typography)(({ theme }) => ({
    display: "block",
    marginTop: theme.spacing(5),
    width: "100%",
}))

export const RoadworkDetails = styled(L2RRoadworkDetails)(() => ({
    flex: 1,
}))

export const Header = styledForMobile("div")(({ theme, isMobile }) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: isMobile ? theme.spacing(5) : theme.spacing(6),
}))